<template>
	<Layout>
		<div class="row">
			<div class="col">
				<br />
				<WebhookSetting :user="currentUser" />
			</div>
		</div>
	</Layout>
</template>

<script>
import { authComputed } from '@/store/helpers'
import Layout from '@/views/layouts/Main'
import WebhookSetting from '@/components/WebhookSetting'

const { VUE_APP_ENV } = process.env

export default {
	name: 'Home',
	page: {
		title: `${
			VUE_APP_ENV !== 'prod' ? VUE_APP_ENV.toUpperCase() : ''
		} Deliveries`,
		meta: [{ name: 'description', content: 'Settings' }]
	},
	components: {
		Layout,
		WebhookSetting
	},
	computed: {
		...authComputed
	}
}
</script>
